import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useHistory } from 'react-router-dom';
import './Sidebar.scss'; // for styling
import { Button } from '@mui/material';
import {
  AddToDrive,
  AssignmentIndOutlined,
  AssignmentTurnedIn,
  BarChart,
  CampaignOutlined,
  Chat,
  Class,
  Contacts,
  CurrencyRupee,
  Dashboard,
  GroupAdd,
  Home,
  NoteAlt,
  People,
  PersonAdd,
  SchoolOutlined,
  Tv,
  VideoCameraFront,
} from '@mui/icons-material';
import PageHeaderNew from '../Components/Common/PageHeader/PageHeaderNew';
import { getCurrentDashboardData } from '../redux/reducers/dashboard.reducer';
import { connect } from 'react-redux';
import { getClientUserId, getRoleArray } from '../redux/reducers/clientUserId.reducer';
import { analysisActions } from '../redux/actions/analysis.action';
import { get } from '../Utilities';
import BackdropLoader from '../Components/Common/BackdropLoader/BackdropLoader';
import { studyBinActions } from '../redux/actions/studybin.actions';
import { homeworkActions } from '../redux/actions/homework.action';

const Sidebar = (props) => {
  const {
    dashboardData,
    roleArray,
    setAnalysisStudentObjectToStore,
    setFolderIdArrayToStore,
    clientUserId,
    clearTests,
  } = props;
  const history = useHistory();
  const location = useLocation();

  const [features, setFeatures] = useState([]);
  const [active, setActive] = useState('home');
  const [isLoading, setIsLoading] = useState(false);
  const [globalNotificationCount, setGlobalNotificationCount] = useState(0);

  // Manage active tab based on current URL path
  useEffect(() => {
    get({ client_user_id: clientUserId }, '/getTotalUnReadMessageCountOfUser').then((res) => {
      if (res && res.success) {
        setGlobalNotificationCount(res.result);
      }
    });
    const path = location.pathname;
    // alert(path);
    if (path === '/') {
      setActive('home');
    } else if (
      path.startsWith('/courses/teachercourse') ||
      (path.startsWith('/course/editcourse') && (roleArray.includes(3) || roleArray.includes(4)))
    ) {
      setActive('courses');
    } else if (path.startsWith('/courses') && roleArray.includes(1)) {
      //
    } else if (path.startsWith('/attendance')) {
      setActive('attendance');
    } else if (path.startsWith('/noticeboard')) {
      setActive('noticeBoard');
    } else if (path.startsWith('/usage')) {
      setActive('usage');
    } else if (path.startsWith('/campaign-dashboard')) {
      setActive('campaign');
    } else if (path.startsWith('/homework')) {
      setActive('homeworkCreator');
    } else if (path.startsWith('/analysis')) {
      setActive('analysis');
    } else if (path.startsWith('/offlineassignments')) {
      setActive('offlineAssignment');
    } else if (path.startsWith('/teacherfees') || path.startsWith('/fees')) {
      setActive('fees');
    } else if (path.startsWith('/liveclasses')) {
      setActive('liveClasses');
    } else if (path.startsWith('/studybin')) {
      setActive('studyBin');

      setFolderIdArrayToStore([]);
    } else if (path.startsWith('/crm')) {
      setActive('crm');
    } else if (path.startsWith('/usage')) {
      setActive('Usage');
    } else if (path.startsWith('/admissions')) {
      setActive('admission');
    } else if (path.startsWith('/allassignments')) {
      setActive('onlineAssignment');
    } else if (path.startsWith('/displaypage')) {
      setActive('displayPage');
    }
  }, [location.pathname]);

  const goToStudentAnalysis = () => {
    setIsLoading(true);
    get({ client_user_id: clientUserId }, '/getOverallAnalysisOfStudent').then((res) => {
      if (res && res.success) {
        const result = res.result;
        // result.first_name = firstName;
        // result.last_name = lastName;
        result.isStudent = true;
        setIsLoading(false);
        setAnalysisStudentObjectToStore(result);
        history.push('/analysis/studentlist');
      }
    });
  };

  const goToAllCourses = () => {
    setIsLoading(true);
    setActive('courses');
    setIsLoading(false);
    history.push({ pathname: '/courses', state: { type: 'allCourses' } });
  };

  const goToMyCourses = () => {
    setIsLoading(true);
    setActive('myCourses');
    setIsLoading(false);
    history.push({ pathname: '/courses', state: { type: 'myCourses' } });
  };

  const goToHomeWorkCreator = () => {
    clearTests();
    history.push({ pathname: '/homework', state: { letsGo: true } });
  };

  useEffect(() => {
    if (dashboardData?.featureOrder) {
      const featuresArray = dashboardData?.featureOrder
        .filter((ele) =>
          [
            'attendance',
            'noticeBoard',
            'homeworkCreator',
            'analysis',
            'offlineAssignment',
            'campaign',
            'fees',
            'courses',
            'myCourses',
            'liveClasses',
            'onlineAssignment',
            'studyBin',
            'crm',
            'Usage',
            'admission',
            'displayPage',
          ].includes(ele),
        )
        .map((ele) => {
          switch (ele) {
            case 'attendance':
              return {
                icon: <People />,
                name: 'Attendance',
                route: '/attendance',
                key: ele,
              };
            case 'noticeBoard':
              return {
                icon: <NoteAlt />,
                name: 'Notice',
                route: '/noticeboard',
                key: ele,
              };
            case 'homeworkCreator':
              return {
                icon: <SchoolOutlined />,
                name: 'Create Test',
                route: '',
                key: ele,
              };
            case 'analysis':
              return roleArray.includes(4) || roleArray.includes(5)
                ? {
                    icon: <AssignmentIndOutlined />,
                    name: 'Analysis',
                    route: '/analysis/teacher',
                    key: ele,
                  }
                : {
                    icon: <AssignmentIndOutlined />,
                    name: 'Analysis',
                    route: '',
                    key: ele,
                  };
            case 'offlineAssignment':
              return {
                icon: <Home />,
                name: 'Offline Assignments',
                route: '/offlineassignments',
                key: ele,
              };
            case 'campaign':
              return {
                icon: <CampaignOutlined />,
                name: 'Campaign',
                route: '/campaign-dashboard',
                key: ele,
              };
            case 'fees':
              return roleArray.includes(4) || roleArray.includes(5)
                ? {
                    icon: <CurrencyRupee />,
                    name: 'Fees',
                    route: '/teacherfees',
                    key: ele,
                  }
                : {
                    icon: <CurrencyRupee />,
                    name: 'Fees',
                    route: '/fees',
                    key: ele,
                  };
            case 'courses':
              return roleArray.includes(1) || roleArray.includes(2)
                ? {
                    icon: <Class />,
                    name: 'All Courses',
                    route: '',
                    key: ele,
                  }
                : {
                    icon: <Class />,
                    name: 'Courses',
                    route: '/courses/teachercourse',
                    key: ele,
                  };
            // case 'myCourses':
            //   return {
            //     icon: <Class />,
            //     name: 'My Courses',
            //     route: '',
            //     key: ele,
            //   };
            case 'liveClasses':
              return {
                icon: <VideoCameraFront />,
                name: 'Live Class',
                route: '/liveclasses',
                key: ele,
              };
            case 'onlineAssignment':
              return {
                icon: <AssignmentTurnedIn />,
                name: 'Online Assignments',
                route: '/allassignments',
                key: ele,
              };
            case 'studyBin':
              return {
                icon: <AddToDrive />,
                name: 'Library',
                route: '/studybin',
                key: ele,
              };
            case 'crm':
              return {
                icon: <Contacts />,
                name: 'CRM',
                route: '/crm',
                key: ele,
              };
            case 'Usage':
              return {
                icon: <BarChart />,
                name: 'Usage',
                route: '/usage',
                key: ele,
              };
            case 'admission':
              return {
                icon: <GroupAdd />,
                name: 'Admission',
                route: '/admissions',
                key: ele,
              };
            case 'displayPage':
              return {
                icon: <Tv />,
                name: 'Display Page',
                route: '/displaypage',
                key: ele,
              };
            default:
              return null;
          }
        })
        .filter(Boolean);

      setFeatures(featuresArray);
    }
  }, [dashboardData, roleArray]);

  return (
    <div id='sidebarId' className='Sidebar__sidebar px-3'>
      <PageHeaderNew isClientColor={false} history={history} />
      <BackdropLoader isLoading={isLoading} />
      <nav className='Sidebar__nav_links'>
        <NavLink
          exact
          style={{ top: '1px', marginTop: '20px' }}
          to='/'
          className={active === 'home' ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'}
        >
          <div className='Sidebar__navButton py-0'>
            <Dashboard />
            <span>Dashboard</span>
          </div>
        </NavLink>
        {roleArray.includes(4) || roleArray.includes(5) ? (
          <>
            {' '}
            <NavLink
              exact
              style={{ top: '1px' }}
              to='/usage'
              className={active === 'usage' ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'}
            >
              <div className='Sidebar__navButton py-0'>
                <BarChart />
                <span>Usage</span>
              </div>
            </NavLink>
            <NavLink
              exact
              style={{ top: '1px' }}
              to='/campaign-dashboard'
              className={active === 'campaign' ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'}
            >
              <div className='Sidebar__navButton py-0'>
                <CampaignOutlined />
                <span>Campaign</span>
              </div>
            </NavLink>
          </>
        ) : null}

        {features.map((ele, index) => {
          let eleStyle = { top: '1px' };
          if (index > 3) {
            eleStyle = { bottom: '1px ' };
          }
          return (
            <NavLink
              key={ele.key}
              to={ele.route || '#'}
              onClick={(e) => {
                if (!ele.route) e.preventDefault(); // prevent '#' or '' from triggering

                if (ele.key === 'analysis') {
                  if (roleArray.includes(1) || roleArray.includes(2)) {
                    e.preventDefault();
                    goToStudentAnalysis();
                  } else {
                  }
                } else if (ele.key === 'courses' && roleArray.includes(1)) {
                  e.preventDefault();
                  goToAllCourses();
                } else if (ele.key === 'myCourses' && roleArray.includes(1)) {
                  e.preventDefault();
                  goToMyCourses();
                } else if (ele.key === 'homeworkCreator') {
                  e.preventDefault();
                  goToHomeWorkCreator();
                }
              }}
              style={eleStyle}
              className={active === ele.key ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'}
            >
              <div className='Sidebar__navButton py-0'>
                {ele.icon} <span>{ele.name}</span>
              </div>
            </NavLink>
          );
        })}
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <div className='Sidebar__chatNav'>
          <NavLink
            exact
            to='/conversations'
            className={active === 'chat' ? 'Sidebar__link Sidebar__active' : 'Sidebar__link'}
          >
            <div
              style={{ border: '1px solid var(--primary-blue)', borderRadius: '12px' }}
              className='Sidebar__navButton primary-text py-0'
            >
              <Chat />
              <span>Let's Chat</span>
            </div>
            {Number(globalNotificationCount) > 0 && (
              <div className='Sidebar__notiCount'>{globalNotificationCount}</div>
            )}
          </NavLink>
        </div>
      </nav>
    </div>
  );
};

const mapStateToProps = (state) => ({
  dashboardData: getCurrentDashboardData(state),
  roleArray: getRoleArray(state),
  clientUserId: getClientUserId(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    setAnalysisStudentObjectToStore: (payload) => {
      dispatch(analysisActions.setAnalysisStudentObjectToStore(payload));
    },
    setFolderIdArrayToStore: (payload) => {
      dispatch(studyBinActions.setFolderIDArrayToStore(payload));
    },
    clearTests: (payload) => {
      dispatch(homeworkActions.clearTests(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
